<template>
  <div>
    <page-title color="grape">Reporting</page-title>
    <cloud-cannon-content
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header"
    />
    <async-loader v-if="reportsLoading"/>
    <template v-else-if="reportTypes.length">
      <report-type-preview
        v-for="(reportType, i) in reportTypes"
        :key="i"
        :reportType="reportType"
        :index="i"
      />
    </template>
    <section v-else>
      <div container>
        <h5 class="lips _text-center"> {{ reportingUserMessage }}</h5>
      </div>
    </section>

    <cloud-cannon-content
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.footer"
    />
  </div>
</template>
<script>
  import ReportTypePreview from './shared/ReportTypePreview.vue'
  import reporting from '@mixins/reporting'
  import PageTitle from './shared/PageTitle'
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'

  export default {
    mixins: [
      fetchable,
      reporting,
      CloudCannonable
    ],
    components: {
      PageTitle,
      ReportTypePreview
    },
    data() {
      return {
        fetchers: [
          {
            action: 'reporting/GET_REPORTS',
            options: {
              params: {
                type: ''
              }
            }
          },
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/reporting.json'
            },
            config: {
              root: true
            }
          }
        ]
      }
    }
  }
</script>
